module.exports = __webpack_public_path__ + "static/media/10pic.3811fe12.jpg";